import React, { useState } from 'react';
import { isEmpty, map } from 'lodash';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { makeStyles } from 'tss-react/mui';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import styles from '../Main/main.styles';
import MedicationReminderSidebar from '../components/MedicationReminderSidebar';
import MedicationReminderList from '../components/MedicationReminderList';

const useStyles = makeStyles()(styles);

function ShowMedications({ refresh, user, setShowMedicationTable, selectedRecipient }) {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [medications, setMedications] = useState([]);
  const [todayMedications, setTodayMedications] = useState([]);
  const [medicationsLoader, setMedicationsLoader] = useState(false);

  const getMedications = React.useCallback(async () => {
    const userId = user?._id || user?.id || '';
    setMedicationsLoader(true);
    try {
      let data = null;
      if (isEmpty(selectedRecipient)) {
        data = await axios.get(`${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/medications`, {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        });
      } else {
        data = await axios.get(
          `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/userMedications/${selectedRecipient}`,
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }
      setMedications(data?.data?.data || []);
    } catch (exception) {
      console.log('Exception', exception);
    }
    setMedicationsLoader(false);
  }, [user, selectedRecipient]);

  const getTodayMedications = React.useCallback(
    async (date = '') => {
      const userId = user?._id || user?.id || '';
      try {
        let data = null;
        if (isEmpty(selectedRecipient)) {
          data = await axios.get(
            `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/todayMedications?date=${date}`,
            {
              headers: {
                'Content-Type': 'application/json',
                authorization: localStorage.getItem('auth'),
              },
            },
          );
        } else {
          data = await axios.get(
            `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/userTodayMedications/${selectedRecipient}?date=${date}`,
            {
              headers: {
                'Content-Type': 'application/json',
                authorization: localStorage.getItem('auth'),
              },
            },
          );
        }
        setTodayMedications(data?.data?.data || []);
      } catch (exception) {
        console.log('Exception', exception);
      }
    },
    [user, selectedRecipient],
  );

  React.useEffect(() => {
    getMedications();
    getTodayMedications();
  }, [getMedications, getTodayMedications]);

  const handleDeleteMedications = async (selected) => {
    const userId = user?._id || user?.id || '';
    try {
      if (!isEmpty(selectedRecipient)) {
        await axios.post(
          `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/deleteRecipientMedications/${selectedRecipient}`,
          {
            selected: JSON.stringify([selected]),
          },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/deleteMedications`,
          {
            selected: JSON.stringify([selected]),
          },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }

      getMedications();
    } catch (exception) {
      console.log('Exception', exception);
    }
  };

  const handleUpdateEvent = async (id, status) => {
    const userId = user?._id || user?.id || '';
    try {
      if (!isEmpty(selectedRecipient)) {
        await axios.put(
          `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/userTodayMedications/${selectedRecipient}`,
          {
            eventId: id,
            status,
            reminder: null,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      } else {
        await axios.put(
          `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/todayMedications`,
          {
            eventId: id,
            status,
            reminder: null,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }

      setTimeout(() => {
        getTodayMedications();
      }, 300);
    } catch (exception) {
      console.log('Exception', exception);
    }
  };

  return (
    <div style={{ width: '95%' }}>
      <h1>{t('pillReminder')}</h1>
      <Grid container item>
        <Grid item sm={12} xs={12} md={4} lg={4}>
          <MedicationReminderSidebar
            todayMedications={todayMedications}
            handleUpdateEvent={handleUpdateEvent}
            onFilterDate={(date) => getTodayMedications(date)}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={8} lg={8}>
          <MedicationReminderList
            setShowMedicationTable={setShowMedicationTable}
            medications={medications}
            loader={medicationsLoader}
            handleDeleteMedications={handleDeleteMedications}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default ShowMedications;
